import { getEmployeeListByApi } from '@/apis/medical/appointment.js';
import cloneDeep from 'lodash/cloneDeep';
import { defineStore } from 'pinia';

export const useMedicalStore = defineStore("medicalStore", {
  state: () => {
    return {
      globalReturnVisitorList: [],
      globalDoctorList: [],
      globalAppointmentDrawerVisible: false,
      globalMedicalSearch: {},
      // 一级页面状态保持数据
      oneLevelData: {},
      globalMdSavePageState: {},
    };
  },
  getters:{
    globalNurseList(state) {
      return state.globalReturnVisitorList.filter((employee) => {
        return employee.role === 10
      })
    },
    storeDoctorList(state) {
      return state.globalReturnVisitorList.filter((employee) => {
        return employee.role === 9
      })
    }
  },
  actions: {
    async getDoctorList(role = 9) {
      this.globalDoctorList = []
      try {
        const response = await getEmployeeListByApi({role, status: 0,})
        if( +response.code === 0) {
          this.globalDoctorList = response.employeeList.map(item => {
            return {
              title: item.medicalEmployee.name,
              value: +item.user.userId,
            }
          })
        }else {
          console.error('doctorFenList')
        }
      }catch(error) {
        if (process.env.NODE_ENV === 'development') {
          console.error(error)
        }
      }
    },
    async getEmployeeList() {
      // 回访人 医生 + 医护 + 咨询师
      this.globalReturnVisitorList = []
      const promiseDoctor = getEmployeeListByApi({role: 9, status: 0})
      const promiseNurse = getEmployeeListByApi({role: 10, status: 0})
      const promiseCounselor = getEmployeeListByApi({role: 11, status: 0})
      return Promise.all([promiseDoctor, promiseNurse, promiseCounselor]).then((responseList) => {
        if(responseList[0].code == '0' && responseList[1].code == '0' && responseList[2].code == '0') {
          let doctorList = [], nurseList = [], counselorList = []
          if(responseList[0].employeeList) {
            doctorList = responseList[0].employeeList.map(item => {
              return {
                title: item.medicalEmployee.name,
                value: +item.user.userId,
                role: +item.medicalEmployee.role,
              }
            })
          }
          if(responseList[1].employeeList) {
            nurseList = responseList[1].employeeList.map(item => {
              return {
                title: item.medicalEmployee.name,
                value: +item.user.userId,
                role: +item.medicalEmployee.role,
              }
            })
          }
          if(responseList[2].employeeList) {
            counselorList = responseList[2].employeeList.map(item => {
              return {
                title: item.medicalEmployee.name,
                value: +item.user.userId,
                role: +item.medicalEmployee.role,
              }
            })
          }
          this.globalReturnVisitorList = [...doctorList, ...nurseList, ...counselorList]
          return Promise.resolve(this.globalReturnVisitorList)
        }else {
          return Promise.reject(new Error('server error'))
        }
      });
    },
    setGlobalAppointmentDrawer(b = false) {
      if(!b) {
        localStorage.removeItem('medical_patient_appointment_flag')
      }
      this.globalAppointmentDrawerVisible = b
    },
    setKeepMedicalSearch(saveKey, raw) {
      const copySearchData = Object.assign({}, this.globalMedicalSearch)
      copySearchData[saveKey] = raw
      this.globalMedicalSearch = copySearchData
    },
    clearAllMedicalSearch() {
      this.globalMedicalSearch = {}
    },
    clearKeyMedicalSearch(key) {
      const deepSearchData = cloneDeep(this.globalMedicalSearch)
      delete deepSearchData[key]
      this.globalMedicalSearch = deepSearchData
    },
    setOneLevelData(data) {
      const sourceRaw = Object.assign({}, this.oneLevelData, data)
      this.oneLevelData = sourceRaw;
    },
    setSavePageStateOfKey(dataKey='defaultVal', data) {
      const waitVarData = Object.assign({}, this.globalMdSavePageState)
      waitVarData[dataKey] = data
      this.globalMdSavePageState = waitVarData;
    },
    delSavePageStateOfKeys(keys=['defaultVal']) {
      // 按数组删除
      const waitVarData = cloneDeep(this.globalMdSavePageState)
      // console.log(keys, waitVarData)
      keys.forEach(dataKey => {
        delete waitVarData[dataKey]
      })
      this.globalMdSavePageState = waitVarData;
    },
    delPageSearchDataOfKeys(keys=['defaultVal']) {
      // 按数组删除
      const waitVarData = cloneDeep(this.globalMedicalSearch)
      // console.log(keys, waitVarData)
      keys.forEach(dataKey => {
        delete waitVarData[dataKey]
      })
      this.globalMedicalSearch = waitVarData;
    },
    clearMedicalSavePageState() {
      this.globalMdSavePageState = {}
    },
    clearAllPageAndSearchData() {
      this.globalMdSavePageState = {}
      this.globalMedicalSearch = {}
      this.oneLevelData = {}
    }
  },
  persist: {
    storage: sessionStorage,
    enabled: true
  }
})
